// Test IDs for the character directory feature.

export const HOME = {
  emergentLink: 'home-emergent-link',
  heroSearchInput: 'hero-search-input',
  heroSearchSubmit: 'hero-search-submit',
  randomCharacterButton: 'random-character-button',
  characterGrid: 'character-grid',
  paginationPrev: 'pagination-prev',
  paginationNext: 'pagination-next',
  filterTestament: 'filter-testament',
  filterImportance: 'filter-importance',
  filterBook: 'filter-book',
  filterClear: 'filter-clear',
};

export const CHARACTER = {
  card: 'character-card',
  name: 'character-name',
  detailName: 'character-detail-name',
  detailScripture: 'character-detail-scripture',
  detailBody: 'character-detail-body',
  bookmarkButton: 'character-bookmark-button',
  shareButton: 'character-share-button',
  iconSlot: 'character-icon-slot',
  importanceTag: 'character-importance-tag',
  testamentTag: 'character-testament-tag',
};

export const FLASHCARDS = {
  page: 'flashcards-page',
  card: 'flashcards-card',
  markKnown: 'flashcards-mark-known',
  markWant: 'flashcards-mark-want',
  markIgnore: 'flashcards-mark-ignore',
  flipButton: 'flashcards-flip-button',
  nextButton: 'flashcards-next-button',
};

export const BOOKMARKS = {
  page: 'bookmarks-page',
  list: 'bookmarks-list',
};

export const NAV = {
  brand: 'nav-brand',
  linkHome: 'nav-link-home',
  linkFlashcards: 'nav-link-flashcards',
  linkBookmarks: 'nav-link-bookmarks',
  linkAbout: 'nav-link-about',
  linkLogin: 'nav-link-login',
  userMenu: 'nav-user-menu',
};
